// extracted by mini-css-extract-plugin
export default {"svg":"CharacterWithAudio_svg__XyVyQ","audio_player":"CharacterWithAudio_audio_player__TAcB2"};